module.exports = __webpack_public_path__ + "static/cutting-through-spiritual-materialism-2fd001eeb880382c7f91ae8c6ca4f29c.jpg";